import { unitMapping } from 'lib/style';

import type { IconColor } from './useIconColor';
import { useIconColor } from './useIconColor';

type Props = {
  size?: keyof typeof unitMapping;
  color?: IconColor;
};

export const Quickplay = ({ size = 3, color }: Props) => {
  const { fill } = useIconColor(color);

  return (
    <svg
      style={{ width: unitMapping[size], height: unitMapping[size] }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M9 7L10 0H8L2 7V9H7L6 16H8L14 9L14 7H9Z" fill={fill} />
    </svg>
  );
};
